import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { useBundle } from "@amzn/react-arb-tools";
import { PRODUCTPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const PriceSection = ({ price }) => {
  const [bundle] = useBundle(PRODUCTPAGE_MESSAGE_BUNDLE_NAME);
  const { originalPriceUSD, originalPriceCAD, priceUSD, priceCAD, discount } =
    price;

  const splitLine = {
    width: "1px",
    backgroundColor: "black",
    height: "50px",
  };

  return (
    <Column spacing="300">
      <Row widths={["fit"]}>
        <Column spacing="100">
          <Text color="error" type="b500" fontFamily="bookerly">
            {priceUSD}
          </Text>
          <Row>
            <Text type="b200" fontFamily="bookerly">
              <s>{originalPriceUSD}</s>
            </Text>
            <Text color="error" type="b200" fontFamily="bookerly">
              {discount}
            </Text>
          </Row>
        </Column>
        <div style={splitLine}></div>
        <Column spacing="100">
          <Text color="error" type="b500" fontFamily="bookerly">
            {priceCAD}
          </Text>
          <Row>
            <Text type="b200" fontFamily="bookerly">
              <s>{originalPriceCAD}</s>
            </Text>
            <Text color="error" type="b200" fontFamily="bookerly">
              {discount}
            </Text>
          </Row>
        </Column>
      </Row>
      <Text fontFamily={"bookerly"} type="b400">
        {t(bundle, "exclusive_amazon_price")}
      </Text>
    </Column>
  );
};

export default PriceSection;
